module.exports = __webpack_public_path__ + "static/media/comingSoon.95d1c9b8.svg";